import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function Marquee() {
  const { lang } = useLang();
  const items = [...STRINGS[lang].marquee, ...STRINGS[lang].marquee];
  return (
    <div data-testid="marquee-band" className="border-y border-white/10 bg-[#12080c] py-4 overflow-hidden relative">
      <div className="mq-track flex gap-12 items-center text-xs uppercase tracking-[0.3em] text-neutral-400 font-light">
        {items.map((item, i) => (
          <span key={i}>• {item}</span>
        ))}
      </div>
    </div>
  );
}
